import m from "../../geodata/es2015/indonesiaHigh";
window.am4geodata_indonesiaHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/indonesiaHigh.js
// module id = null
// module chunks = 